import {useContext} from 'react';
//mui
import {Box, Stepper, Step, StepLabel, Typography, StepIconProps} from '@mui/material';
//icons
import {ReactComponent as StepIcon} from '@icons/signup-step.svg';
import {ReactComponent as ActiveStepIcon} from '@icons/signup-active-step.svg';
import {ReactComponent as DoneStepIcon} from '@icons/signup-done-step.svg';
//constants
import {CAPTION, VERTICAL} from '@/utils/constants';
//context
import {OrganizationSignUpContext} from '@/pages/Organization/OrganizationSignUp/OrganizationSignUpContext';
//helpers
import {VerticalStepperDataType, verticalStepperData} from './helpers';
//styles
import {verticalStepperStyle} from './VerticalStepper.styles';

const StepperIcon = (props: StepIconProps) => {
	const {active, completed} = props;
	return <Box>{active ? <ActiveStepIcon /> : completed ? <DoneStepIcon /> : <StepIcon />}</Box>;
};

const VerticalStepper = () => {
	const {activeStep} = useContext(OrganizationSignUpContext);

	return (
		<Box sx={verticalStepperStyle.wrapper}>
			<Stepper activeStep={activeStep} orientation={VERTICAL} sx={verticalStepperStyle.stepper}>
				{verticalStepperData.map((step: VerticalStepperDataType) => (
					<Step key={step.label}>
						<StepLabel
							sx={verticalStepperStyle.label}
							StepIconComponent={StepperIcon}
							optional={<Typography variant={CAPTION}>{step?.description}</Typography>}
						>
							{step.label}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</Box>
	);
};

export default VerticalStepper;
